import React, { useState, useMemo } from 'react';
import ReactECharts from 'echarts-for-react';
import { Box } from '@material-ui/core';
import dayjs from 'dayjs';
import { useSelector } from 'dva';
import TypeChangeBtnGroup from '@/components/type_change_btn_group/TypeChangeBtnGroup';
import TooltipMl from './Tooltip';

const Page = ({ height, handleDateChange }) => {
  const typeList = [
    {
      label: '今日',
      value: 'TODAY',
      calcDay: 0,
    },
    {
      label: '7天',
      value: 'WEEK',
      calcDay: 7,
    },
    {
      label: '30天',
      value: 'MONTH',
      calcDay: 30,
    },
  ];
  const { trackingLogTrendData } = useSelector((state) => state.userBehavior);

  const [type, setType] = useState('WEEK');
  const barData = useMemo(() => {
    let xData = [];
    let yData = [];
    if (trackingLogTrendData) {
      if (type === 'TODAY') {
        xData.push(dayjs().format('MM/DD'));
        const Date = dayjs().format('YYYY-MM-DD');
        const value =
          trackingLogTrendData?.find((i) => i.behaveDate === Date)?.num || 0;
        yData.push(value);
      } else if (type === 'WEEK') {
        for (let index = 6; index >= 0; index--) {
          xData.push(dayjs().subtract(index, 'day').format('MM/DD'));
          const Date = dayjs().subtract(index, 'day').format('YYYY-MM-DD');
          const value =
            trackingLogTrendData?.find((i) => i.behaveDate === Date)?.num || 0;
          yData.push(value);
        }
      } else {
        for (let index = 29; index >= 0; index--) {
          xData.push(dayjs().subtract(index, 'day').format('MM/DD'));
          const Date = dayjs().subtract(index, 'day').format('YYYY-MM-DD');
          const value =
            trackingLogTrendData?.find((i) => i.behaveDate === Date)?.num || 0;
          yData.push(value);
        }
      }
    }
    console.log('xData', xData, yData);
    return { xData, yData };
  }, [trackingLogTrendData, type]);
  const option = {
    title: {
      // text: 'ECharts 入门示例',
    },
    tooltip: {
      trigger: 'item',
      textStyle: {
        fontSize: 12,
        lineHeight: 30,
        fontWeight: 'bold',
      },
      formatter: (params) => {
        return `<div>
          <div style="height:30px">行为事件数量</div>
          <div><span>${params.name}</span><span style="margin-left:16px">${params.value}个</span></div>
        </div>`;
        // return `
        // 行为事件数量<br/>

        // ${params.name} &nbsp &nbsp ${params.value}个
        // `;
      },
      borderWidth: 0,
    },
    legend: {
      // data: ['销量'],
    },
    xAxis: {
      data: barData?.xData,
    },
    yAxis: {},
    series: [
      {
        // name: '销量',
        type: 'bar',
        sampling: 'sum',
        data: barData.yData,
        // [
        //   5,
        //   20,
        //   36,
        //   10,
        //   10,
        //   20,
        //   5,
        //   20,
        //   36,
        //   10,
        //   10,
        //   20,
        //   5,
        //   20,
        //   36,
        //   10,
        //   10,
        //   20,
        //   5,
        //   20,
        //   36,
        //   10,
        //   10,
        //   20,
        //   5,
        //   20,
        //   36,
        //   10,
        //   10,
        //   20,
        // ],
      },
    ],
  };

  const changeType = (v) => {
    const currentCalcValue = typeList?.find((i) => i.value === v)?.calcDay;
    handleDateChange(currentCalcValue);
    setType(v);
  };

  return (
    <Box>
      <Box display="flex" justifyContent="space-between">
        <Box display="flex" flex="1">
          用户行为趋势
          <TooltipMl info="按单个用户纬度展示该用户特定时间段内行为事件总数的变化趋势" />
        </Box>
        <Box flex="1">
          <TypeChangeBtnGroup
            typeList={typeList}
            change={changeType}
            checkedIndex={1}
          />
        </Box>
      </Box>
      <ReactECharts
        option={option}
        style={{ height }}
        opts={{ renderer: 'svg' }}
      />
    </Box>
  );
};

export default Page;
